import React from "react";
import ReactApexChart from "react-apexcharts";
import { Card, CardContent, Typography, Box, Button } from "@mui/material";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

const ShadowChart = ({ refreshClick }) => {
  const chartData = {
    series: [
      {
        name: "Sun Height",
        type: "line",
        data: [2, 4, 6, 8, 10, 10, 8, 6, 4, 2],
      },
      {
        name: "Horizon Height",
        type: "bar",
        data: [0, 10, 15, 20, 25, 30, 5, 0, 1],
      },
    ],
    options: {
      chart: {
        height: 200,
        type: "line",
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [3, 0],
        curve: "smooth",
      },
      markers: {
        size: 4,
      },
      title: {
        text: undefined,
      },
      xaxis: {
        categories: [
          "10 AM",
          "11 AM",
          "12 PM",
          "1 PM",
          "2 PM",
          "3 PM",
          "4 PM",
          "5 PM",
          "6 PM",
        ],
      },
      yaxis: [{ show: false }, { opposite: true, show: false }],
      grid: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 8,
          border: {
            show: true,
            color: "#A8A8A8", // Border color
            width: 2, // Border width
          },
          fill: {
            opacity: 0, // Hollow bars
          },
        },
      },
      colors: ["#FFD700", "#A8A8A8"],
    },
  };

  return (
    <Box sx={{}}>
      <Button
        size="small"
        onClick={() => {
          refreshClick();
        }}
        variant="outlined"
        endIcon={<RefreshOutlinedIcon />}
      >
        New Answer
      </Button>
    </Box>
  );
};

const ShadowChartCard = ({ handleRestartClick, shadowLoss, energyLoss }) => {
  return (
    <Card
      sx={{
        maxWidth: 400,
        margin: "auto",
        padding: { xs: 0.5, md: 2 },
        borderRadius: { xs: 0.5, md: 2 },
        boxShadow: 2,
      }}
    >
      <CardContent>
        {/* Values Section */}
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Box textAlign="center">
            <Typography variant="subtitle3" color="text.secondary">
              Shadow cover
            </Typography>
            <Typography variant="h5" fontWeight="bold" color="#00FA9A">
              {shadowLoss}%
            </Typography>
          </Box>
          <Box textAlign="center">
            <Typography variant="subtitle3" color="text.secondary">
              Energy loss
            </Typography>
            <Typography variant="h5" fontWeight="bold" color="#EE4B2B">
              -{energyLoss}%
            </Typography>
          </Box>
        </Box>

        {/* Chart Section */}
        <ShadowChart
          refreshClick={handleRestartClick}
          shadowLoss={shadowLoss}
        ></ShadowChart>
      </CardContent>
    </Card>
  );
};

export default ShadowChartCard;
